var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex gap-6"},[_c('div',{staticClass:"flex-1"},[_c('DashboardPanel')],1),_c('div',{staticClass:"flex-1 flex flex-col gap-6"},[_c('ControlPanel'),_c('FavoriteUsers')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }